import { createFileRoute, useParams } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import { VStack } from '@/components/Layout';
import { MOCK_ONLY_FEATURE_FLAG } from '@/constants/featureFlags';
import { featureFlags } from '@/lib/env';
import { DeviceLicenseTable } from './-components/DeviceLicenseTable';
import { useGetDeviceLicenses } from './-query';
export const Route = createFileRoute('/_staff/devices/$id/_layout/licenses/')({
  component: DeviceLicensesTab
});
function DeviceLicensesTab() {
  const {
    id
  } = useParams({
    from: '/_staff/devices/$id/_layout/licenses/'
  });
  const isMockEnabled = featureFlags.check(MOCK_ONLY_FEATURE_FLAG);
  // フラグ無効時は DemoDB を読まない（ガード評価前のクエリ実行を防ぐ）
  const {
    data,
    isPending
  } = useGetDeviceLicenses(id, {
    enabled: isMockEnabled
  });

  // MOCK_ONLY フラグ無効時は本番同様に非表示（直接 URL アクセス対策）
  if (!isMockEnabled) {
    return <NotFound />;
  }
  return <VStack className="h-full min-h-0 gap-4 p-10">
      <div className="min-h-0 flex-1 overflow-auto">
        <DeviceLicenseTable data={data?.items ?? []} isPending={isPending} />
      </div>
    </VStack>;
}